import { useAppDispatch, useAppSelector } from "../../../store/hooks";
import { setHighlightedTasks } from "../../../store/search";
import { ganttChartVerticalValues } from "../../../utils/ganttChartValues";

const VerticalShiftColumn = ({
  fill,
  xPosition,
  yPosition,
  height,
}: {
  fill?: string;
  xPosition: number;
  yPosition: number;
  height: number;
}) => {
  const dispatch = useAppDispatch();
  const { verticalColumnWidth } = useAppSelector(
    (state) => state.ganttChartSlice,
  );
  const { pixelsPerHour } = useAppSelector((state) => state.timelineSlice);

  if (!verticalColumnWidth || !pixelsPerHour) return null;

  const colWidth =
    verticalColumnWidth >= ganttChartVerticalValues.verticalViewMinColumnWidth
      ? verticalColumnWidth
      : ganttChartVerticalValues.verticalViewMinColumnWidth;

  return (
    <div
      style={{
        position: "absolute",
        left: xPosition,
        top: yPosition,
        width: colWidth,
        height,
        backgroundColor: fill,
      }}
      onClick={() => dispatch(setHighlightedTasks([]))}
    />
  );
};

export default VerticalShiftColumn;
